module.exports = __webpack_public_path__ + "img/log__circl.6068e882.svg";